export const ROOT_DOMAIN = process.env.REACT_APP_ROOT_DOMAIN || 'telecalx.com';
// Hosts that are TeleCalX's own, never a company (admin: Super Admin panel; infra: Infrastructure Control Centre).
const NON_TENANT = new Set(['app', 'api', 'www', 'admin', 'infra']);

export function parseHost(hostname = window.location.hostname) {
  const suffix = `.${ROOT_DOMAIN}`;
  if (!hostname.endsWith(suffix)) return { kind: 'app', slug: null };
  const sub = hostname.slice(0, -suffix.length);
  if (!sub || sub.includes('.') || NON_TENANT.has(sub)) return { kind: 'app', slug: null };
  return { kind: 'tenant', slug: sub };
}

const origin = (sub) => {
  const { protocol, port } = window.location;
  return `${protocol}//${sub}.${ROOT_DOMAIN}${port ? `:${port}` : ''}`;
};

export const appUrl = (path = '/') => `${origin('app')}${path}`;
export const adminUrl = (path = '/') => `${origin('admin')}${path}`;
export const infraUrl = (path = '/') => `${origin('infra')}${path}`;
export const tenantUrl = (slug, path = '/') => `${origin(slug)}${path}`;
export const goTo = (url) => window.location.assign(url);

/** A TeleCalX address to go to after signing in: a path on this site (/billing), or a full URL on ROOT_DOMAIN. */
export function isOwnUrl(url) {
  // A path, but not "//host" or "/\host", which browsers treat as another site.
  if (typeof url === 'string' && url.startsWith('/')) return !/^\/[\\/]/.test(url);
  try {
    const host = new URL(url).hostname;
    return host === ROOT_DOMAIN || host.endsWith(`.${ROOT_DOMAIN}`);
  } catch {
    return false;
  }
}

export const usableMemberships = (session) =>
  (session?.memberships || []).filter((m) => m.status === 'active' && m.tenant_status === 'active');

/** Where to send a user right after they have a session. */
export function routeAfterLogin(session, navigate, next) {
  if (next && isOwnUrl(next)) return goTo(next);
  if (session.user.is_super_admin) return goTo(adminUrl());
  if (session.user.is_infra_admin) return goTo(infraUrl());
  const orgs = usableMemberships(session);
  if (orgs.length === 0) return navigate('/create-org', { replace: true });
  if (orgs.length === 1) return goTo(tenantUrl(orgs[0].slug));
  if (session.last_tenant_slug) return goTo(tenantUrl(session.last_tenant_slug));
  return navigate('/select-org', { replace: true });
}

export function apiError(err, fallback = 'Something went wrong') {
  const detail = err?.response?.data?.detail;
  if (Array.isArray(detail)) return detail.map((d) => d.msg).join(', ');
  if (typeof detail === 'string') return detail;
  if (detail && typeof detail === 'object' && detail.message) return detail.message; // {code, message}
  if (err && !err.response) return 'Network error. Please check your connection.';
  return fallback;
}
